module.exports = __webpack_public_path__ + "price1.2d28f401.png";